<template>
  <div>
    <h1>MESSAGE</h1>
  </div>
</template>

<script>
export default {
  name: "ViewMessage",
};
</script>

<style>
</style>